export default {
  //  1-Chi trích tạo nguồn cải cách tiền lương 
  ExpenseForSalaryReform: 1,

  // 2-Chi đầu tư
  ExpenseInvest: 2,

  // 3-Chi thường xuyền
  ExpenseRegular: 3,


};
